/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function AccountingTable10Info({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const {
    rows = [],
    debitCounterpartLabels = [],
    creditCounterpartLabels = [],
    totals = {}
  } = values;

  const num = (v) => (v && v !== "" && !isNaN(v) ? parseFloat(v) : 0);
  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const addRow = () => {
    const nextIdx = rows.length > 0 ? Math.max(...rows.map(r => r.index)) + 1 : 1;
    const newRow = {
      index: nextIdx,
      customerName: "",
      openingDebitBalance: 0,
      debitSideValues: [0, 0, 0, 0, 0],
      debitSideTotal: 0,
      creditSideValues: [0, 0, 0, 0, 0],
      creditSideTotal: 0,
      closingDebitBalance: 0,
    };
    setFieldValue("rows", [...rows, newRow]);
  };

  const removeRow = (idx) => {
    if (rows.length <= 1) return;
    setFieldValue("rows", rows.filter((_, i) => i !== idx));
  };

  // Logic tính toán tự động
  useEffect(() => {
    let newTotals = {
      openingDebitBalance: 0,
      debitSideValues: [0, 0, 0, 0, 0],
      debitSideTotal: 0,
      creditSideValues: [0, 0, 0, 0, 0],
      creditSideTotal: 0,
      closingDebitBalance: 0,
    };

    const newRows = rows.map((row) => {
      const dTotal = (row.debitSideValues || []).reduce((acc, curr) => acc + num(curr), 0);
      const cTotal = (row.creditSideValues || []).reduce((acc, curr) => acc + num(curr), 0);
      const closing = num(row.openingDebitBalance) + dTotal - cTotal;

      // Update Column totals data
      newTotals.openingDebitBalance += num(row.openingDebitBalance);
      (row.debitSideValues || []).forEach((v, i) => { if (i < 5) newTotals.debitSideValues[i] += num(v); });
      newTotals.debitSideTotal += dTotal;
      (row.creditSideValues || []).forEach((v, i) => { if (i < 5) newTotals.creditSideValues[i] += num(v); });
      newTotals.creditSideTotal += cTotal;
      newTotals.closingDebitBalance += closing;

      return {
        ...row,
        debitSideTotal: dTotal,
        creditSideTotal: cTotal,
        closingDebitBalance: closing,
      };
    });

    const hasChanged = JSON.stringify(newRows) !== JSON.stringify(rows) || JSON.stringify(newTotals) !== JSON.stringify(totals);
    if (hasChanged) {
      setFieldValue("rows", newRows);
      setFieldValue("totals", newTotals);
    }
  }, [JSON.stringify(rows.map(r => ({ o: r.openingDebitBalance, d: r.debitSideValues, c: r.creditSideValues })))]);

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#f9f9f9" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 4px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "50%" }}>
          <div>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.unit} onChange={(e) => setFieldValue("unit", e.target.value)} /></div>
          <div>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, width: "300px" }} value={values.address} onChange={(e) => setFieldValue("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "50%" }}>
          <div style={{ fontWeight: "bold" }}>Mẫu số S04b11-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC ngày 27 tháng 10<br /> năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h3 style={{ margin: 0, textTransform: "uppercase" }}>BẢNG KÊ SỐ 10</h3>
        <h3 style={{ margin: 0, textTransform: "uppercase" }}>PHẢI THU CỦA KHÁCH HÀNG (TK 131)</h3>
        <div style={{ marginTop: "10px", fontStyle: "italic" }}>
          Tháng <input disabled={containView} style={s.inputDottedSmall} value={values.month} onChange={(e) => setFieldValue("month", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "60px" }} value={values.year} onChange={(e) => setFieldValue("year", e.target.value)} />
        </div>
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "40px" }} rowSpan={2}>Số TT</th>
              <th style={{ ...s.th, minWidth: "150px" }} rowSpan={2}>Tên người mua</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Số dư Nợ đầu tháng</th>
              <th style={s.th} colSpan={6}>Ghi Nợ TK 131, ghi Có các TK:</th>
              <th style={s.th} colSpan={6}>Ghi Có TK 131, ghi Nợ các TK:</th>
              <th style={{ ...s.th, width: "100px" }} rowSpan={2}>Số dư Nợ cuối tháng</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={2}>#</th>}
            </tr>
            <tr>
              {/* Debit Side Labels */}
              {[...Array(5)].map((_, i) => (
                <th key={`dh-${i}`} style={{ ...s.th, width: "80px" }}>
                  <input disabled={containView} style={s.inputTableCenter} value={debitCounterpartLabels[i] || ""} onChange={(e) => {
                    const newLabels = [...debitCounterpartLabels];
                    newLabels[i] = e.target.value;
                    setFieldValue("debitCounterpartLabels", newLabels);
                  }} />
                </th>
              ))}
              <th style={{ ...s.th, width: "90px" }}>Cộng Nợ TK 131</th>
              {/* Credit Side Labels */}
              {[...Array(5)].map((_, i) => (
                <th key={`ch-${i}`} style={{ ...s.th, width: "80px" }}>
                  <input disabled={containView} style={s.inputTableCenter} value={creditCounterpartLabels[i] || ""} onChange={(e) => {
                    const newLabels = [...creditCounterpartLabels];
                    newLabels[i] = e.target.value;
                    setFieldValue("creditCounterpartLabels", newLabels);
                  }} />
                </th>
              ))}
              <th style={{ ...s.th, width: "90px" }}>Cộng Có TK 131</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>C</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              <th style={s.th}>5</th>
              <th style={s.th}>6</th>
              <th style={s.th}>7</th>
              <th style={s.th}>8</th>
              <th style={s.th}>9</th>
              <th style={s.th}>10</th>
              <th style={s.th}>11</th>
              <th style={s.th}>12</th>
              <th style={s.th}>13</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, rIdx) => (
              <tr key={rIdx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={row.index} onChange={(e) => {
                  const newRows = [...rows];
                  newRows[rIdx].index = e.target.value;
                  setFieldValue("rows", newRows);
                }} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={row.customerName} onChange={(e) => {
                  const newRows = [...rows];
                  newRows[rIdx].customerName = e.target.value;
                  setFieldValue("rows", newRows);
                }} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={row.openingDebitBalance} onChange={(e) => {
                  const newRows = [...rows];
                  newRows[rIdx].openingDebitBalance = e.target.value;
                  setFieldValue("rows", newRows);
                }} /></td>
                {/* Debit Side Values 1-5 */}
                {[...Array(5)].map((_, i) => (
                  <td key={`dv-${rIdx}-${i}`} style={s.td}>
                    <input disabled={containView} type="number" style={s.inputTableRight} value={row.debitSideValues[i] || 0} onChange={(e) => {
                      const newRows = [...rows];
                      const newVals = [...(newRows[rIdx].debitSideValues || [0, 0, 0, 0, 0])];
                      newVals[i] = e.target.value;
                      newRows[rIdx].debitSideValues = newVals;
                      setFieldValue("rows", newRows);
                    }} />
                  </td>
                ))}
                <td style={{ ...s.td, textAlign: "right", padding: "0 8px", fontWeight: "bold", backgroundColor: "#fafafa" }}>{fmt(row.debitSideTotal)}</td>
                {/* Credit Side Values 7-11 */}
                {[...Array(5)].map((_, i) => (
                  <td key={`cv-${rIdx}-${i}`} style={s.td}>
                    <input disabled={containView} type="number" style={s.inputTableRight} value={row.creditSideValues[i] || 0} onChange={(e) => {
                      const newRows = [...rows];
                      const newVals = [...(newRows[rIdx].creditSideValues || [0, 0, 0, 0, 0])];
                      newVals[i] = e.target.value;
                      newRows[rIdx].creditSideValues = newVals;
                      setFieldValue("rows", newRows);
                    }} />
                  </td>
                ))}
                <td style={{ ...s.td, textAlign: "right", padding: "0 8px", fontWeight: "bold", backgroundColor: "#fafafa" }}>{fmt(row.creditSideTotal)}</td>
                <td style={{ ...s.td, textAlign: "right", padding: "0 8px", fontWeight: "bold", color: num(row.closingDebitBalance) < 0 ? "red" : "blue" }}>{fmt(row.closingDebitBalance)}</td>
                {!containView && (
                  <td style={{ ...s.td, textAlign: "center" }}>
                    <button type="button" style={s.removeBtn} onClick={() => removeRow(rIdx)}>–</button>
                  </td>
                )}
              </tr>
            ))}
            {/* Totals Row */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#eee" }}>
              <td style={{ ...s.td, textAlign: "center" }} colSpan={2}>Cộng</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 8px" }}>{fmt(totals.openingDebitBalance)}</td>
              {totals.debitSideValues?.map((v, i) => (
                <td key={`tdv-${i}`} style={{ ...s.td, textAlign: "right", padding: "0 8px" }}>{fmt(v)}</td>
              ))}
              <td style={{ ...s.td, textAlign: "right", padding: "0 8px" }}>{fmt(totals.debitSideTotal)}</td>
              {totals.creditSideValues?.map((v, i) => (
                <td key={`tcv-${i}`} style={{ ...s.td, textAlign: "right", padding: "0 8px" }}>{fmt(v)}</td>
              ))}
              <td style={{ ...s.td, textAlign: "right", padding: "0 8px" }}>{fmt(totals.creditSideTotal)}</td>
              <td style={{ ...s.td, textAlign: "right", padding: "0 8px" }}>{fmt(totals.closingDebitBalance)}</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox mt={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm khách hàng</SoftButton>
          </SoftBox>
        )}
      </div>      
    </SoftBox>
  );
}
